import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import LawsuitPostSummary from '../../components/lawsuit/LawsuitPostSummary';
import { supabase } from '../../utils/supabaseClient';

export default function LawsuitSlugPage(props) {
  // console.log(props.lawsuit)
  return (
    <div>
      <Header image={props.lawsuit.product_image} title={`${props.lawsuit.injuries[0]} & ${props.lawsuit.title} Case Review`} description={`Get Connected with a ${props.lawsuit.title} Lawyer | Were you diagnosed with any of the following cancers after ${props.lawsuit.title} use? Learn more on how you may be entitled to compensation.`} keywords={`${props.lawsuit.title}, lawsuit`} />
      <LawsuitPostSummary lawsuit={props.lawsuit} did={`000-000-0000`} source="Craftwise LLC" />
    </div>
  )
}

export const getStaticPaths = async () => {
  const { data: lawsuits } = await supabase
    .from('lawsuits')
    .select('slug, published')
    .eq("published", true)

  const paths = lawsuits.map(({ slug }) => ({
    params: {
      slug: slug.toString()
    }
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug } }) => {
  const { data: lawsuit } = await supabase
    .from('lawsuits')
    .select(`
    id, 
    product_image, 
    product_image_source,
    product_cover_image,
    title,
    subtitle,
    products,
    injuries,
    carcinogen,
    active_lawsuit,
    carcinogen_related,
    slug,  
    top_settlement,
    overview, 
    patient_story_1,
    patient_image_1,
    injuries_sideeffects,
    caseinfo_settlement,
    past_lawsuits,
    current_lawsuits, 
    eligibility, 
    scientific_studies, 
    lawyer_questions,
    timeline, 
    defendants,
    fact_1,
    fact_2,
    fact_3, 
    cited_articles,
    question_1,
    answer_1,
    question_2,
    answer_2,
    question_3,
    answer_3,
    question_4,
    answer_4
  `)
    .eq('slug', slug)
    .single()


  return {
    props: {
      lawsuit
    },
    revalidate: 60, // 1 minute
  }
}
